import * as NUMBER from 'constant/number'
import * as TABLE from 'constant/table'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closeSubTable } from 'action/table'
import { saveCategoriesOrder } from 'action/category'
import ReactDragListView from 'react-drag-listview'
import { Row, Col, Modal, Table } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import _ from 'lodash'
import PropTypes from 'prop-types'
import styles from 'view/component/navbar/component/nav-breadcrumbs/styles'
import subColumns from './columns'

// eslint-disable-next-line max-lines-per-function
export const SubTable = ({ subCategories, subLoading, saveCategoriesOrder, closeSubTable, category, show }) => {
  const [subDataSource, setSubDataSource] = useState(subCategories)

  const subDragProps = {
    handleSelector: 'a',
    onDragEnd (fromIndex, toIndex) {
      const data = _.isEmpty(subDataSource) ? subCategories : subDataSource
      setSubDataSource()
      const item = data.splice(fromIndex - NUMBER.ONE, NUMBER.ONE)[0]
      data.splice(toIndex - NUMBER.ONE, NUMBER.ZERO, item)
      setSubDataSource(data)
    }
  }

  const handleClose = () => closeSubTable()

  return (<>
    <Modal
      bodyStyle={{
        backgroundColor: '#F7F7F7'
      }}
      confirmLoading={subLoading}
      okText='Save'
      onCancel={() => {
        handleClose()
      }}
      onOk={async () => {
        await saveCategoriesOrder(subDataSource, true)
        closeSubTable()
      }}
      title='Order Site Categories'
      visible={show}
    >
      <Row>
        <Col
          span={24}
        >
          <Row>
            <a
              className={styles.return_link}
              onClick={handleClose}
            >
              <LeftOutlined />
                Return
            </a>
          </Row>
          <div className='ps-4'>
            <Row>
              <label className='pb-2'>{category.name}</label>
            </Row>
            <ReactDragListView {...subDragProps}>
              <Table
                columns={subColumns}
                dataSource={subDataSource}
                pagination={false}
                rowKey={({ uuid }) => uuid}
                scroll={{ x: TABLE.SCROLL }}
              />
            </ReactDragListView>
          </div>

        </Col>
      </Row>
    </Modal>

  </>
  )
}

SubTable.propTypes = {
  category: PropTypes.object,
  closeSubTable: PropTypes.func,
  saveCategoriesOrder: PropTypes.func,
  show: PropTypes.bool,
  subCategories: PropTypes.array,
  subLoading: PropTypes.bool
}

export default connect(
  (state) => ({
    category: state.table.showSubTable.category,
    show: state.table.showSubTable.show,
    subCategories: state.table.showSubTable.sub_categories,
    subLoading: state.loader.categorySubmitting
  }),
  (dispatch) => ({
    closeSubTable: bindActionCreators(closeSubTable, dispatch),
    saveCategoriesOrder: bindActionCreators(saveCategoriesOrder, dispatch)
  })

)(SubTable)
